export default {
  nav (state, data) {
    state.nav = data.navbar.filter((link) => {
      if (link.id === 3 && (!data.services || data.services.length === 0)) {
        link.hidden = true
      }
      return link
    })
    state.nav.unshift({
      id: 2,
      name: 'Главная',
      route: 'home',
      child_navigator: []
    })
  },
  contacts (state, data) {
    state.contacts = data.contacts
  },
  article (state, data) {
    state.article = data.news
  },
  photos (state, data) {
    state.photos = data.gallery
  },
  categories (state, data) {
    state.categories = data.category_documents
  },
  news (state, { next, data }) {
    if (next) {
      state.news.data.push(...data.news.data)
      state.news.next_page_url = data.news.next_page_url
    } else {
      state.news = data.news
    }
  },
  gallery (state, { next, data }) {
    if (next) {
      state.gallery.data.push(...data.gallery.data)
      state.gallery.next_page_url = data.gallery.next_page_url
    } else {
      state.gallery = data.gallery
    }
  },
  department (state, data) {
    state.department = data.department
  },
  homeNews (state, data) {
    state.homeNews = data.news.filter((item, index) => index < 3)
  },
  homeGallery (state, data) {
    state.homeGallery = data.gallery
  },
  homeDocuments (state, data) {
    state.homeDocuments = data.documents
  },
  homeStatistics (state, data) {
    state.homeStatistics = [
      {
        title: 'Общеобразовательные организации',
        count: data.schools_department.filter(item => item.get_school && item.get_school.category_id === 1).length
      },
      {
        title: 'Дошкольные образовательные организации',
        count: data.schools_department.filter(item => item.get_school && item.get_school.category_id === 2).length
      },
      {
        title: 'Учреждения дополнительного образования',
        count: data.schools_department.filter(item => item.get_school && item.get_school.category_id !== 2 && item.get_school.category_id !== 1).length
      }]
  },
  links (state, data) {
    state.links = data.links
  },
  slider (state, data) {
    state.slider = data.slider
  },
  documents (state, data) {
    state.documents = data.documents
  },
  document (state, data) {
    state.document = data.documents
  },
  managements (state, data) {
    state.managements = data.managements
  },
  institutions (state, data) {
    state.institutions = data.institutions
  },
  partitions (state, data) {
    state.partitions = data.child_navbar
  },
  materials (state, data) {
    state.materials = data.child_navbar
    state.materials_child_navigator = data.child_navigator
  },
  material (state, data) {
    state.material = data.material
  },
  appeals (state, data) {
    state.appeals = data.appeals
    state.list_appeals = data.list_appeals
  }
}
